import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Mail, MapPin, Phone, Building2, Scale } from "lucide-react";

export default function ImpressumPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="impressum-page">
      <Navbar />

      <section className="pt-20 bg-[#002FA7]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <span className="text-xs uppercase tracking-[0.2em] font-semibold text-[#FFD700]">Rechtliches</span>
          <h1
            className="text-4xl sm:text-5xl tracking-tighter font-black text-white mt-2"
            style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
            data-testid="impressum-heading"
          >
            Impressum
          </h1>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-10">

            {/* Angaben gemäß § 5 TMG */}
            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4 flex items-center gap-2" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
                <Building2 className="w-5 h-5 text-[#002FA7]" />
                Angaben gemäß § 5 DDG
              </h2>
              <div className="text-sm text-[#475569] leading-relaxed space-y-1 pl-7">
                <p className="font-semibold text-[#0A0A0A]">AtoB Logistic Solutions GmbH</p>
                <p>Schneiderstraße 63</p>
                <p>40764 Langenfeld (Rheinland)</p>
                <p>Deutschland</p>
              </div>
            </div>

            {/* Vertreten durch */}
            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4 flex items-center gap-2" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
                <Scale className="w-5 h-5 text-[#002FA7]" />
                Vertreten durch
              </h2>
              <div className="text-sm text-[#475569] leading-relaxed space-y-2 pl-7">
                <p>Geschäftsführer: <span className="text-[#0A0A0A] font-medium">Admir Basic</span></p>
                <p className="text-xs text-[#475569] mt-1">
                  Ist nur ein Geschäftsführer bestellt, so vertritt er die Gesellschaft allein. Sind mehrere Geschäftsführer bestellt, wird die Gesellschaft durch zwei Geschäftsführer oder durch einen Geschäftsführer gemeinsam mit einem Prokuristen vertreten.
                </p>
              </div>
            </div>

            {/* Kontakt */}
            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4">Kontakt</h2>
              <div className="text-sm text-[#475569] leading-relaxed space-y-2 pl-7">
                <div className="flex items-center gap-2">
                  <Phone className="w-4 h-4 text-[#002FA7] shrink-0" />
                  <span>+49 2173 2046451</span>
                </div>
                <div className="flex items-center gap-2">
                  <Mail className="w-4 h-4 text-[#002FA7] shrink-0" />
                  <a href="mailto:info@atob-logistics.de" className="hover:text-[#002FA7] transition-colors">info@atob-logistics.de</a>
                </div>
                <div className="flex items-start gap-2">
                  <MapPin className="w-4 h-4 text-[#002FA7] shrink-0 mt-0.5" />
                  <span>Schneiderstraße 63, 40764 Langenfeld (Rheinland)</span>
                </div>
              </div>
            </div>

            {/* Registereintrag */}
            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Registereintrag</h2>
              <div className="text-sm text-[#475569] leading-relaxed space-y-1 pl-7">
                <p>Eintragung im Handelsregister</p>
                <p>Registergericht: Amtsgericht Düsseldorf</p>
                <p>Registernummer: <span className="text-[#0A0A0A] font-medium">HRB 112510</span></p>
                <p>Rechtsform: Gesellschaft mit beschränkter Haftung (GmbH)</p>
                <p>Stammkapital: <span className="text-[#0A0A0A] font-medium">25.000,00 EUR</span></p>
                <p>Gesellschaftsvertrag vom: 17.02.2026</p>
              </div>
            </div>

            {/* Unternehmensgegenstand */}
            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Unternehmensgegenstand</h2>
              <div className="text-sm text-[#475569] leading-relaxed pl-7">
                <p>
                  Die Erbringung von Logistiklösungen und -dienstleistungen im europäischen Raum, insbesondere die Organisation, Durchführung und Vermittlung von Transporten und Speditionsleistungen aller Art, die Entwicklung und Bereitstellung von Logistikkonzepten, Lagerhaltung und Transportmanagement, Dienstleistungen im Bereich Supply Chain Management, Zoll- und Exportabwicklung, Beratungs- und Vermittlungsleistungen im Logistikbereich sowie alle damit zusammenhängenden Geschäfte und Dienstleistungen.
                </p>
              </div>
            </div>

            {/* Umsatzsteuer-ID */}
            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Umsatzsteuer-ID</h2>
              <div className="text-sm text-[#475569] leading-relaxed pl-7">
                <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:</p>
                <p className="text-[#0A0A0A] font-medium mt-1">DE462568816</p>
              </div>
            </div>

            {/* Steuernummer */}
            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Steuernummer</h2>
              <div className="text-sm text-[#475569] leading-relaxed pl-7">
                <p className="text-[#0A0A0A] font-medium">135/5703/2917</p>
              </div>
            </div>

            {/* Streitschlichtung */}
            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Streitschlichtung</h2>
              <div className="text-sm text-[#475569] leading-relaxed space-y-3 pl-7">
                <p>
                  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
                  <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#002FA7] hover:underline">
                    https://ec.europa.eu/consumers/odr/
                  </a>
                </p>
                <p>Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
                <p>
                  Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
                </p>
              </div>
            </div>

            {/* Haftung für Inhalte */}
            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Haftung für Inhalte</h2>
              <div className="text-sm text-[#475569] leading-relaxed space-y-3 pl-7">
                <p>
                  Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                </p>
                <p>
                  Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                </p>
              </div>
            </div>

            {/* Haftung für Links */}
            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Haftung für Links</h2>
              <div className="text-sm text-[#475569] leading-relaxed space-y-3 pl-7">
                <p>
                  Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
                </p>
                <p>
                  Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                </p>
              </div>
            </div>

            {/* Urheberrecht */}
            <div>
              <h2 className="text-xl font-bold text-[#0A0A0A] mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Urheberrecht</h2>
              <div className="text-sm text-[#475569] leading-relaxed space-y-3 pl-7">
                <p>
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
                </p>
                <p>
                  Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
